import { MutationCallbacks } from '../../../shared/types/mutation';
import useFetch from '../useFetch';
import { getOrganisations } from '../../../shared/service/data';
import { IOrgFilter } from '../../../shared/types/filters';

export default function useOrganisationsList(
  value: IOrgFilter,
  { enable, onSuccess, onError }: MutationCallbacks,
) {
  return useFetch(
    ['organisationsList'],
    async () => {
      return await getOrganisations(value);
    },
    {
      enabled: enable,
      onSuccess,
      onError,
    },
  );
}
